// @flow

// import {toast} from 'react-toastify'

import type {
  SearchItem,
  SearchListItem,
  BabyListItemFoundStateType,
  Supplier,
  Dispatch,
  ThunkAction,
  Action,
} from "../types"
import {getNextFoundStateBulk} from "../reducers/search-items"
import {flatten, isNil} from "lodash"
import {post, put} from "../client"
// import i18n from '../i18n'

export const setSearchItems = (
  searchItems: $ReadOnlyArray<SearchItem>,
  searchItemSuppliers: $ReadOnlyArray<Supplier>
): Action => ({
  type: "SET_SEARCH_ITEMS",
  searchItems,
  searchItemSuppliers,
})

export const toggleSearchListItem = (productId: number): Action => ({
  type: "TOGGLE_SEARCH_LIST_ITEM",
  productId,
})

export const toggleFoundRemarksItem = (searchItemId: number): Action => ({
  type: "TOGGLE_FOUND_REMARKS_ITEM",
  searchItemId,
})

export const activateFoundRemarksItems = (
  searchItemIds: $ReadOnlyArray<number>
): Action => ({
  type: "ACTIVATE_FOUND_REMARKS_ITEMS",
  searchItemIds,
})

// export const activateAllFoundRemarksItems = (): Action => ({
//   type: "ACTIVATE_ALL_FOUND_REMARKS_ITEMS",
// })
// export const deactivateAllFoundRemarksItems = (): Action => ({
//   type: "DEACTIVATE_ALL_FOUND_REMARKS_ITEMS",
// });

export const closeAllSearchItems = (): Action => ({
  type: "CLOSE_ALL_SEARCH_ITEMS",
})

export const bulkToggleSearchItems = (
  searchListItem: SearchListItem
): ThunkAction => {
  return (dispatch: Dispatch) => {
    const state = getNextFoundStateBulk(searchListItem)
    const searchListItemIds = searchListItem.items.map((i) => i.uniqId)
    const babyListItemIds = searchListItem.items
      .filter((i) => isNil(i.babyListItemFoundId))
      .map((i) => i.id)
    const founds = searchListItem.items
      .filter((i) => i.babyListItemFoundId)
      .map((i) => ({
        foundId: i.babyListItemFoundId,
        babyListItemId: i.id,
      }))
    return post(`/baby_list_item/bulk_toggle`, {
      babyListItemIds,
      founds,
      state,
    }).then((response) => {
      if (response.errors) {
        // TODO set errors
        // toast.error(i18n.t('toast.user.update.error'))
      } else {
        const babyListItemFoundIds = response.data.babyListItemFoundIds
        dispatch(
          setSearchItemFoundStateBulk(
            searchListItem.productId,
            babyListItemFoundIds,
            searchListItemIds,
            state
          )
        )
        if (state == "todo") {
          // toggle found remarks
          dispatch(
            activateFoundRemarksItems(searchListItem.items.map((i) => i.uniqId))
          )
        }
      }
    })
  }
}

export const updateSearchItemFound = (
  productId: number,
  babyListItemId: number,
  babyListItemFoundId: number,
  searchListItemId: number,
  state: ?BabyListItemFoundStateType,
  isPhotographed: boolean,
  remarks: ?string
): ThunkAction => {
  return (dispatch: Dispatch) => {
    let payload = {state, isPhotographed}
    if (remarks !== null || remarks !== undefined) {
      payload.remarks = remarks
    }
    return put(
      `/baby_list_item/${babyListItemId}/found/${babyListItemFoundId}`,
      payload
    ).then((response) => {
      if (response.errors) {
        // TODO set errors toast.error(i18n.t('toast.user.update.error'))
      } else {
        const babyListItemFoundId = response.data.babyListItemFoundId
        const foundRemarks = response.data.foundRemarks
        const isPhotographed = response.data.isPhotographed
        dispatch(
          setSearchItemFoundState(
            productId,
            babyListItemFoundId,
            searchListItemId,
            state,
            foundRemarks,
            isPhotographed
          )
        )
        if (state == "todo") {
          dispatch(toggleFoundRemarksItem(searchListItemId))
        }
      }
    })
  }
}

export const addSearchItemFound = (
  productId: number,
  babyListItemId: number,
  searchListItemId: number,
  state: ?BabyListItemFoundStateType
): ThunkAction => {
  return (dispatch: Dispatch) => {
    return post(`/baby_list_item/${babyListItemId}/found`, {
      state,
      remarks: "",
    }).then((response) => {
      if (response.errors) {
        // TODO set errors toast.error(i18n.t('toast.user.update.error'))
      } else {
        const babyListItemFoundId = response.data.babyListItemFoundId
        dispatch(
          setSearchItemFoundState(
            productId,
            babyListItemFoundId,
            searchListItemId,
            state,
            "",
            false
          )
        )
      }
    })
  }
}

export const setSearchItemFoundState = (
  productId: number,
  babyListItemFoundId: number,
  searchListItemId: number,
  state: ?BabyListItemFoundStateType,
  remarks: string,
  isPhotographed: boolean
): Action => ({
  type: "SET_SEARCH_ITEM_FOUND_STATE",
  productId,
  babyListItemFoundId,
  searchListItemId,
  state,
  remarks,
  isPhotographed,
})

export const setSearchItemFoundStateBulk = (
  productId: number,
  babyListItemFoundIds: $ReadOnlyArray<number>,
  searchListItemIds: $ReadOnlyArray<number>,
  state: ?BabyListItemFoundStateType
): Action => ({
  type: "SET_SEARCH_ITEM_FOUND_STATE_BULK",
  productId,
  babyListItemFoundIds,
  searchListItemIds,
  state,
})

export const markAllAsPhotographed = (
  searchListItems: $ReadOnlyArray<SearchListItem>
): ThunkAction => {
  return (dispatch: Dispatch) => {
    // Only items that have state 'OK' (and that are not yet marked as isPhotographed) can be toggled
    const searchItems = flatten(searchListItems.map((item) => item.items))
    const babyListItemFoundIds = searchItems
      .filter(
        (item) =>
          item.babyListItemFoundId && item.state == "ok" && !item.isPhotographed
      )
      .map((item) => item.babyListItemFoundId)
    if (babyListItemFoundIds.length > 0) {
      return post(`/baby_list_item/bulk_photographed`, {
        babyListItemFoundIds,
      }).then((response) => {
        if (response.errors) {
          // TODO set errors
          // toast.error(i18n.t('toast.user.update.error'))
        } else {
          // dispatch(() => {})
          dispatch(setSearchItemsPhotographedLocal(babyListItemFoundIds))
        }
      })
    }
  }
}

export const setSearchItemsPhotographedLocal = (
  babyListItemFoundIds: $ReadOnlyArray<number>
): Action => ({
  type: "SET_SEARCH_ITEM_PHOTOGRAPHED_LOCAL",
  babyListItemFoundIds,
})
